import React, { useEffect, useState } from "react";
import { MenuItem } from "@mui/material";
import { Tooltip } from "@material-ui/core";
import InfoIcon from "@mui/icons-material/Info";
import Select from "./common/Select";

export const ArbitratorConflictDropDown = ({
  name,
  onChange,
  value,
  label,
  options,
}) => {
  return (
    <Select
      name={name}
      onChange={(e) => onChange(e)}
      value={value}
      label={label}
      customRenderItems={true}
      options={options}
      renderHook={(o, index) => {
        const hasWarning = o.isAtRoundCount || o.isPairedThreeTimesToday;
        const hasConflict = o.isConflicted;
        const hasAny = hasConflict || hasWarning;
        
        // Build combined reason - only include warnings if there's no conflict
        const reasons = hasConflict 
          ? o.reason 
          : [
              o.isAtRoundCount ? "At round count" : null,
              o.isPairedThreeTimesToday ? "Paired 3 times today" : null
            ].filter(Boolean).join(". ");
        
        // Determine class: conflict takes precedence over warning
        const className = hasConflict ? "arbitrator-conflict" : (hasWarning ? "arbitrator-warning" : "");
        
        return (
          <MenuItem key={o.id + index + Math.random()} value={o.id}>
            <span className={className}>
              {hasAny ? (
                <Tooltip title={reasons}>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    {o?.name.trim()}
                    <InfoIcon sx={{ fontSize: 14, marginLeft: "2px" }} />
                  </span>
                </Tooltip>
              ) : (
                o?.name.trim()
              )}
            </span>
          </MenuItem>
        );
      }}
    ></Select>
  );
};
